import {
  BulkActionContainerCol,
  Col,
  Table,
  TableActionBarRow,
} from "melco-ui";
import { useTranslation } from "react-i18next";

import { useEffect, useState } from "react";

import { useRolesContext } from "../../hooks/roles/useRolesContext";
import { useManageSuppliers } from "../../hooks/suppliers/useManageSuppliers";
import { Search } from "../search/Search";
import { PublishedState } from "../state/PublishedState";
import { SupplierAddEditDrawer } from "./drawer/SupplierAddEditDrawer";
import { TableCellLink } from "../table/TableCellLink";
import { ControlcenterMelcoModelsSupplier } from "melco-shared-logic";
import { FormattedDate } from "../table/FormattedDate";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";
import { BulkActionCount } from "../table/BulkActionCount";
import { useTableSelection } from "../../hooks/table/useTableSelection";
import { BulkActionDeleteSuppliers } from "./BulkActionDeleteSuppliers";

type ManageSuppliersListPropTypes = {
  isSupplierDrawerOpen: boolean;
  setSupplierDrawerOpenFunction: (v: boolean) => void;
  supplierIdToUpdate: string;
  // supplierType: string;
};

export const ManageSuppliersList: React.FC<ManageSuppliersListPropTypes> = ({
  supplierIdToUpdate,
  isSupplierDrawerOpen,
  setSupplierDrawerOpenFunction,
}) => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,

    refetch,
    searchQueryChange,
  } = useManageSuppliers(ALL_PUBLISHED_STATES);
  const { t } = useTranslation();
  const { roles } = useRolesContext();

  useEffect(() => {
    setIsSupplierDrawerOpenValue(isSupplierDrawerOpen);
  }, [isSupplierDrawerOpen]);

  useEffect(() => {
    setSupplierIdToUpdateValue(supplierIdToUpdate);
  }, [supplierIdToUpdate]);

  const [isSupplierDrawerOpenValue, setIsSupplierDrawerOpenValue] =
    useState<boolean>(isSupplierDrawerOpen);
  const [supplierIdToUpdateValue, setSupplierIdToUpdateValue] =
    useState<string>(supplierIdToUpdate);

  const handleEditClick = (supplierId: string) => {
    setIsSupplierDrawerOpenValue(true);
    setSupplierIdToUpdateValue(supplierId);
  };

  const { selectedRowKeys, setSelectedRowKeys, rowSelection } =
    useTableSelection<ControlcenterMelcoModelsSupplier>(() => {});

  const columns = [
    {
      title: t("managesuppliers.table.columns.id"),
      key: "id",
      sorter: true,
      render: (rowObj: any) => {
        return roles.SYSTEM_SUPPLIERS_EDIT ? (
          <TableCellLink
            onClick={() => {
              handleEditClick(rowObj.id);
            }}
            to={""}
          >
            {rowObj.id}
          </TableCellLink>
        ) : (
          rowObj.id
        );
      },
    },
    // {
    //   title: t("managesuppliers.table.columns.code"),
    //   key: "code",
    //   dataIndex: "code",
    //   sorter: true,

    // },
    {
      title: t("managesuppliers.table.columns.name"),
      key: "name",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: t("managesuppliers.table.columns.type"),
      key: "supplier_type",
      dataIndex: "supplier_type",
      sorter: true,
    },

    {
      title: t("managesuppliers.table.columns.created_date"),
      key: "created_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsSupplier) => (
        <div> {<FormattedDate date={rowObj.created_date} />}</div>
      ),
    },
    {
      title: t("managesuppliers.table.columns.publish_date"),
      key: "publish_date",
      sorter: true,

      render: (rowObj: ControlcenterMelcoModelsSupplier) => (
        <div> {<FormattedDate date={rowObj.publish_date} />}</div>
      ),
    },
    {
      title: t("managesuppliers.table.columns.publish_state"),
      key: "publish_state",
      sorter: true,
      render: (rowobj: ControlcenterMelcoModelsSupplier) => {
        return <PublishedState publishedState={rowobj.publish_state ?? 1} />;
      },
    },
  ];

  const closeDrawerAction = () => {
    setIsSupplierDrawerOpenValue(false);
    setSupplierDrawerOpenFunction(false);
    refetch();
  };

  return (
    <>
      <TableActionBarRow>
        <Col>
          {
            <Search
              onSearchInputChange={(query: string) => searchQueryChange(query)}
            />
          }
        </Col>

        {roles.SYSTEM_SUPPLIERS_DELETE && (
          <BulkActionContainerCol>
            <BulkActionCount selectedCount={selectedRowKeys.length} />
            <BulkActionDeleteSuppliers
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={setSelectedRowKeys}
              refetch={refetch}
              data={data}
            />
          </BulkActionContainerCol>
        )}
      </TableActionBarRow>

      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="id"
        rowSelection={roles.SYSTEM_SUPPLIERS_DELETE ? rowSelection : undefined}
        noDataMessage={t("managesuppliers.basic.no_suppliers_message")}
        errorComponent={errorComponent}
      />

      {isSupplierDrawerOpenValue && (
        <SupplierAddEditDrawer
          isSupplierDrawerOpen={isSupplierDrawerOpenValue}
          setSupplierDrawerOpen={setSupplierDrawerOpenFunction}
          supplierIdToUpdate={supplierIdToUpdateValue}
          closeDrawerAction={() => {
            closeDrawerAction();
          }}
        />
      )}
    </>
  );
};
